/** React Query key for GET /connections/status (header CTAs). */
export const CONNECTIONS_STATUS_QUERY_KEY = "connections-status" as const;

export function connectionsStatusQueryKey(studioId: string) {
  return [CONNECTIONS_STATUS_QUERY_KEY, studioId] as const;
}
